import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./SectionsHotel.css";
import "swiper/css";
import "swiper/css/pagination";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Autoplay, Pagination } from "swiper/modules";
import moment from "moment";
import { Link } from "react-router-dom";

const SectionsHotel = () => {
  const swiperRef = useRef(null);
  const [activeTab, setActiveTab] = useState("All");

  const todayDate = moment().format("YYYY-MM-DD");
  const tomorrowDate = moment().add(1, "days").format("YYYY-MM-DD");
  const roomConfig = encodeURIComponent(
    '[{"adults":2,"children":0,"childrenAges":[]}]'
  );

  const categories = [
    {
      label: "All",
      icon: "https://img.icons8.com/?size=100&id=45075&format=png&color=000000",
    },
    {
      label: "City",
      icon: "https://img.icons8.com/?size=100&id=hFxOoQSMxi28&format=png&color=000000",
    },
    {
      label: "Beach",
      icon: "https://img.icons8.com/?size=100&id=31799&format=png&color=000000",
    },
    {
      label: "Outdoor",
      icon: "https://img.icons8.com/?size=100&id=920&format=png&color=000000",
    },
    {
      label: "Relax",
      icon: "https://img.icons8.com/?size=100&id=74521&format=png&color=000000",
    },
    {
      label: "Romance",
      icon: "https://img.icons8.com/?size=100&id=24907&format=png&color=000000",
    },
  ];

  const data = [
    {
      img: "https://res.cloudinary.com/dtljonz0f/image/upload/c_auto,ar_4:3,w_3840,g_auto/f_auto/q_auto/v1/shutterstock_2414539851_ss_non-editorial_dcx0bm?_a=BAVAZGGf0",
      name: "Dubai",
      review: "1200",
      category: "City",
    },
    {
      img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Maldives",
      review: "850",
      category: "Beach",
    },
    {
      img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "London",
      review: "980",
      category: "City",
    },
    {
      img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=1938&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Bali",
      review: "1500",
      category: "Relax",
    },
    {
      img: "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Swiss Alps",
      review: "600",
      category: "Outdoor",
    },
    {
      img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Paris",
      review: "2000",
      category: "Romance",
    },
    {
      img: "https://images.unsplash.com/photo-1500835556837-99ac94a94552?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Cancun",
      review: "750",
      category: "Beach",
    },
    {
      img: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=1988&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Tokyo",
      review: "1100",
      category: "City",
    },
    {
      img: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?q=80&w=1972&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Cinque Terre",
      review: "900",
      category: "Romance",
    },
    {
      img: "https://images.unsplash.com/photo-1589553416260-f586c8f1514f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Banff",
      review: "550",
      category: "Outdoor",
    },
    {
      img: "https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=1778&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Rishikesh",
      review: "400",
      category: "Relax",
    },
    {
      img: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Goa",
      review: "1800",
      category: "Beach",
    },
    {
      img: "https://images.unsplash.com/photo-1496568816309-51d7c20e3b21?q=80&w=2031&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "New York",
      review: "2500",
      category: "City",
    },
    {
      img: "https://media.istockphoto.com/id/1145450965/photo/santorini-island-greece.jpg?s=612x612&w=0&k=20&c=AY_kxRrkTjbDLhqpotxgW8CZp4ovEIM1tRdTrvXKcAM=",
      name: "Santorini",
      review: "1300",
      category: "Romance",
    },
    {
      img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Phuket",
      review: "700",
      category: "Relax",
    },
  ];

  const filteredData =
    activeTab === "All"
      ? data
      : data.filter((item) => item.category === activeTab);

  return (
    <section className="section destination-section_HOTEl_TG">
      <div
        className="container"
        style={{ position: "relative", zIndex: "10000" }}
      >
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-10 text-center">
            <div className="section-header section-header_hotelss text-center">
              <h2 className="mb-2 sections_h_fives">
                Quick and easy trip planner
              </h2>
              <p className="sub-title">
                Pick a vibe and explore the top destinations
              </p>
            </div>
          </div>
        </div>

        <div className="tabs tabs_section mb-4 text-center d-flex justify-content-center gap-3 ">
          {categories.map((cat) => (
            <div
              key={cat.label}
              className={`tab-button d-flex flex-row gap-2 align-items-center px-3 py-2 ${
                activeTab === cat.label ? "active-tab" : ""
              }`}
              onClick={() => setActiveTab(cat.label)}
            >
              <img
                src={cat.icon}
                alt={`${cat.label} icon`}
                style={{ width: "25px", height: "25px" }}
                className="img_section_hotels"
              />
              <span>{cat.label}</span>
            </div>
          ))}
        </div>

        <Swiper
          slidesPerView={"auto"}
          spaceBetween={10}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 2, spaceBetween: 10 },
            576: { slidesPerView: 2.2, spaceBetween: 15 },
            768: { slidesPerView: 4, spaceBetween: 20 },
            1200: { slidesPerView: 6, spaceBetween: 24 },
          }}
          autoplay
          loop
          modules={[Autoplay]}
          className="mySwiper"
          style={{ paddingBottom: "20px" }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {filteredData.map((item, index) => (
            <SwiperSlide key={index} style={{ width: 306, marginRight: 24 }}>
              <Link
                className="destination-item mb-4"
                
                to={`/hotelmodify?from=119805&city=${item.name}&startDate=${todayDate}&endDate=${tomorrowDate}&rooms=${roomConfig}`}
              >
                <img src={item.img} alt={item.name} className="hotel_section_img"/>
                <div className="destination-info text-center">
                  <div className="destination-content">
                    <h5 className="mb-1 text-white section_item_package">
                      {item.name}
                    </h5>
                  </div>
                </div>
                <div className="overlay-circle-link">
                  <i className="isax isax-arrow-right-1" />
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          className="custom-next3"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <FaChevronRight />
        </div>
        <div
          className="custom-prev3"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <FaChevronLeft />
        </div>
      </div>
    </section>
  );
};

export default SectionsHotel;
